import { useLocation, useNavigate } from "react-router-dom";

type SharedFooterProps = {
  onPreturiClick?: () => void;
};

export default function SharedFooter({ onPreturiClick }: SharedFooterProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const isLanding = location.pathname === "/";

  const scrollToSection = (sectionId: string) => {
    if (isLanding) {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return (
    <footer className="sf-footer">
      <style>{`
        .sf-footer { background: #0B1220; padding: 48px 0; }
        .sf-wrap { max-width: 1200px; margin: 0 auto; padding: 0 24px; }
        .sf-top { display: flex; justify-content: space-between; align-items: start; gap: 24px; flex-wrap: wrap; }
        .sf-brand-block { display: flex; flex-direction: column; gap: 6px; }
        .sf-brand { font-family: 'Sora', sans-serif; font-size: 24px; font-weight: 700; color: #FFFFFF; margin: 0; }
        .sf-tagline { font-size: 12px; letter-spacing: 1px; color: #94A3B8; margin: 0; }
        .sf-operator { font-size: 11px; letter-spacing: 0.8px; color: #64748B; margin: 0; }
        .sf-cols { display: flex; gap: 48px; }
        .sf-col { display: flex; flex-direction: column; gap: 10px; }
        .sf-col-title { font-size: 11px; letter-spacing: 0.12em; color: #64748B; text-transform: uppercase; margin: 0; }
        .sf-footer .sf-link { font-size: 12px; letter-spacing: 1px; color: #E2E8F0; cursor: pointer; background: none; border: none; padding: 0; font-family: inherit; text-align: left; transition: color 150ms; text-decoration: none; display: block; }
        .sf-footer .sf-link:hover { color: #FFFFFF; }
        .sf-line { height: 1px; background: #1E293B; margin: 24px 0 14px; border: none; }
        .sf-copy { font-size: 11px; letter-spacing: 0.8px; color: #64748B; margin: 0; }
        .sf-disclaimer { font-size: 10px; letter-spacing: 0.6px; color: #475569; line-height: 1.5; margin-top: 8px; max-width: 900px; }
        @media (max-width: 900px) { .sf-top { flex-direction: column; } }
        @media (max-width: 640px) { .sf-cols { flex-direction: column; gap: 24px; } }
      `}</style>
      <div className="sf-wrap">
        <div className="sf-top">
          <div className="sf-brand-block">
            <h3 className="sf-brand">NIS2PASS</h3>
            <p className="sf-tagline">
              Platformă de conformitate NIS2 pentru România.
            </p>
            <p className="sf-operator">
              Operat de Compliance Made Easy S.R.L.
            </p>
            <p className="sf-operator">contact@nis2pass.ro</p>
          </div>
          <div className="sf-cols">
            <div className="sf-col">
              <span className="sf-col-title">Platformă</span>
              <button
                type="button"
                className="sf-link"
                onClick={() => scrollToSection("v40-sec-cycle")}
              >
                Cum funcționează
              </button>
              <button
                type="button"
                className="sf-link"
                onClick={() => scrollToSection("v40-sec-modules")}
              >
                Module
              </button>
              <button
                type="button"
                className="sf-link"
                onClick={onPreturiClick ?? (isLanding ? () => scrollToSection("v40-sec-pricing") : () => navigate("/preturi"))}
              >
                Prețuri
              </button>
              <button
                type="button"
                className="sf-link"
                onClick={() => scrollToSection("v40-sec-faq")}
              >
                Întrebări frecvente
              </button>
              <button
                type="button"
                className="sf-link"
                onClick={() => scrollToSection("v40-sec-about")}
              >
                Despre noi
              </button>
              <button
                type="button"
                className="sf-link"
                onClick={() => navigate("/contact")}
              >
                Contact
              </button>
            </div>
            <div className="sf-col">
              <span className="sf-col-title">Legal</span>
              <a href="/termeni-si-conditii" className="sf-link">
                Termeni și Condiții
              </a>
              <a href="/politica-de-confidentialitate" className="sf-link">
                Politica de Confidențialitate
              </a>
              <a href="/politica-de-rambursare" className="sf-link">
                Politica de Rambursare
              </a>
              <a href="/politica-de-cookie-uri" className="sf-link">
                Politica Cookie-uri
              </a>
            </div>
            <div className="sf-col">
              <span className="sf-col-title">Resurse oficiale</span>
              <a
                href="https://dnsc.ro"
                target="_blank"
                rel="noopener noreferrer"
                className="sf-link"
              >
                DNSC (dnsc.ro)
              </a>
              <a
                href="http://platformanis2.ro/"
                target="_blank"
                rel="noopener noreferrer"
                className="sf-link"
              >
                Platforma NIS2@RO
              </a>
              <a
                href="https://pnrisc.dnsc.ro/"
                target="_blank"
                rel="noopener noreferrer"
                className="sf-link"
              >
                PNRISC
              </a>
              <a
                href="https://www.dnsc.ro/pagini/CVD"
                target="_blank"
                rel="noopener noreferrer"
                className="sf-link"
              >
                CVD
              </a>
            </div>
          </div>
        </div>
        <hr className="sf-line" />
        <p className="sf-copy">
          © 2026 Compliance Made Easy SRL. Toate drepturile rezervate.
        </p>
        <p className="sf-disclaimer">
          NIS2PASS este un instrument auxiliar de conformare dezvoltat de
          Compliance Made Easy SRL, nu oferă sfaturi juridice. Deciziile finale
          de clasificare aparțin exclusiv DNSC conform OUG 155/2024.
        </p>
      </div>
    </footer>
  );
}
